import { AxiosResponse } from 'axios';
import { CanceledRequestError } from './Errors/CanceledRequestError';
import { ClientNetworkError } from './Errors/ClientNetworkError';
import { ILogger } from '@/Contracts';
import { fromGenericError } from '@/Services/BKAPI/Reducers/ErrorReducer';

export const onFullFilled = (response: AxiosResponse) => response;

const ignoredErrors = [CanceledRequestError, ClientNetworkError];
export const makeOnReject =
  (logger: ILogger) =>
    (error?: any): Promise<any> => {
      const errorInstance = fromGenericError(error);
      if (!ignoredErrors.some(ignoredError => errorInstance instanceof ignoredError)) {
        logger.logError(errorInstance);
      }
      return Promise.reject(errorInstance);
    };
